// 同意画面テンプレート
import React, { useState, useEffect } from 'react';
import Block from '../molecules/Block';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import Heading from '../molecules/Heading';
import AgreementBox from '../molecules/AgreementBox';
import { clause_type } from '../Const';

interface Clauses {
  heading: string;
  types: number[];
  main_btn_label: string;
  sub_btn_label: string;
  leave_text: string;
  sub_btn_area: JSX.Element | undefined;
}

interface Props {
  agreement_text: string[];
  clauses: Clauses;
  main_btn_func: () => void;
  sub_btn_area?: JSX.Element;
  is_disagreement?: boolean; // 不同意したかのbool値 true：不同意 false:不同意以外
}

const AgreementTemplate: React.FC<Props> = ({
  agreement_text,
  clauses,
  main_btn_func,
  is_disagreement,
}) => {
  // 各ポップアップに同意
  const [agreed, setAgreed] = useState({});
  // 全ての同意文に同意
  const [all_agree, setAllagree] = useState(false);

  // 同意した同意文の番号を追加
  const check_agree = (id: number, agreement: boolean) => {
    setAgreed(agreed => {
      return { ...agreed, [id]: agreement };
    });
  };

  // 全ての同意文に同意したか確認、同意していたら最下部のボタンを活性化
  useEffect(() => {
    if (clauses.types.length === Object.keys(agreed).length) {
      Object.values(agreed).forEach(value => {
        value === true ? setAllagree(true) : setAllagree(false);
      });
    }
  }, [agreed]);

  return (
    <>
      <Heading label={clauses.heading} size="l" />
      <Block
        label="同意書確認"
        content={
          <>
            {agreement_text.map((data: any, index: number) => {
              return (
                <AgreementBox
                  agreement_content={data}
                  label_number={clauses.types[index]}
                  key={index}
                  check_agree={check_agree}
                />
              );
            })}
            <div className="content-box">
              <Annotation
                text={`※同意内容をご確認いただき、同意する場合は、「${clauses.main_btn_label}」ボタンを押して下さい。`}
              />
              <CenterButton
                btn_class="arrow-right"
                label={clauses.main_btn_label}
                is_disabled={all_agree && !is_disagreement ? false : true}
                handleClick={main_btn_func}
              />
            </div>
            {clauses.sub_btn_area && clauses.sub_btn_area}
          </>
        }
      />
    </>
  );
};

export default AgreementTemplate;
